export enum PosLocationsErrorBannerMessages {
  ERROR_MESSAGE_LINKING_POS = 'There was an issue linking your Point of Sale system. Please try again.',
}
